var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHunt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.637 27.741c.894.001 1.62.73 1.62 1.63S10.531 31 9.636 31c-.894 0-1.619-.73-1.619-1.63s.725-1.629 1.62-1.629zm12.744.001c.895.001 1.62.73 1.62 1.63S23.275 31 22.38 31c-.893 0-1.618-.73-1.618-1.63s.725-1.629 1.62-1.629zM9.592 1.001c.44 0 .815.157 1.126.47.31.313.472.695.482 1.147v7.392c1.357-1.06 2.953-1.588 4.79-1.588 1.07 0 2.088.21 3.052.632a8.36 8.36 0 0 1 2.547 1.717 8.103 8.103 0 0 1 1.745 2.557c.428.98.642 2.025.642 3.134v7.562c-.01.451-.17.834-.482 1.147-.31.312-.686.469-1.124.469a1.53 1.53 0 0 1-1.125-.47 1.566 1.566 0 0 1-.467-1.148V16.46c0-.656-.127-1.277-.382-1.863a4.958 4.958 0 0 0-1.033-1.532 4.927 4.927 0 0 0-1.521-1.04 4.535 4.535 0 0 0-1.853-.384 4.6 4.6 0 0 0-1.86.378 4.875 4.875 0 0 0-2.554 2.58 4.69 4.69 0 0 0-.375 1.863v7.562c0 .451-.156.834-.467 1.147-.31.312-.69.469-1.139.469-.437-.001-.812-.158-1.123-.47A1.566 1.566 0 0 1 8 24.02V2.617c0-.452.156-.834.467-1.147A1.53 1.53 0 0 1 9.59 1z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunt);
export default __webpack_public_path__ + "static/media/HUNT.9a63d1f66256177cd3b04440cf8bef93.svg";
export { ForwardRef as ReactComponent };